import type { SelectOption } from '@bennows/boows-react';
import type { TFunction } from 'i18next';
import { OPERATOR_ROLES } from './useOperators';

/** The four roles for the role select, each with what it may do (spec 140 §4.2). */
export function roleOptions(t: TFunction): SelectOption[] {
  return OPERATOR_ROLES.map((role) => ({ id: role, label: t(`roles.${role}`), hint: t(`roleHints.${role}`) }));
}
